import cx from 'classnames';
import { Button } from '@ontruck/orc';
import { useState, useCallback } from 'react';
import { LazyTippy } from 'utils/Tippy';
import PropTypes from 'prop-types';

import EditTimesTooltipContent from './EditTimesTooltipContent';

const EditTimesTooltip = ({ className, enabled, children, timeFrom, timeTo, onSave, disabled }) => {
  const [visible, setVisible] = useState(false);
  const show = () => setVisible(true);
  const hide = () => setVisible(false);

  const handleSave = useCallback(
    ({ timeFrom: modifiedTimeFrom, timeTo: modifiedTimeTo }) => {
      onSave({
        timeFrom: modifiedTimeFrom,
        timeTo: modifiedTimeTo,
      });
      hide();
    },
    [onSave]
  );

  if (!enabled) {
    return children;
  }

  return (
    <div className="stop__editable" data-testid="edit-times">
      <div className="stop__editable_times_container">{children}</div>
      <div
        className={cx('stop__editable_edit_container', {
          visible,
        })}
      >
        <LazyTippy
          appendTo={document.body}
          content={
            <EditTimesTooltipContent timeFrom={timeFrom} timeTo={timeTo} onSave={handleSave} />
          }
          theme="light"
          placement="bottom"
          className={className}
          interactive
          visible={visible}
          onClickOutside={hide}
        >
          <div>
            <Button
              ghost
              skin="primary"
              icon="edit"
              iconPosition="left"
              size="XS"
              disabled={disabled}
              onClick={show}
            />
          </div>
        </LazyTippy>
      </div>
    </div>
  );
};

EditTimesTooltip.defaultProps = {
  disabled: false,
  enabled: true,
};

EditTimesTooltip.propTypes = {
  disabled: PropTypes.bool,
  enabled: PropTypes.bool,
  timeFrom: PropTypes.string,
  timeTo: PropTypes.string,
  onSave: PropTypes.func,
};

export default EditTimesTooltip;
